/**
 * KitValidation
 * Data validation utilities
 */

import KitConstants from '../constants';

export const validateEmail = (email: string): boolean => {
  return KitConstants.EmailRegex.test(email);
};

export default {
  validateEmail,
};
